import React from "react";
import Layout from "components/layout";
import GetInTouch from "components/getInTouch";
import HeroBanner from "../HeroBanner/index";
import UsersReviews from "../reusableComponents/UsersReviews/UsersReviews";
import { reviewsData } from "../reusableComponents/UsersReviews/reviewsConfig";
import ServiceClients from "../ServiceClients/index";
import CertificationSamples from "../CertificationSamples/index";
import Rating from "../Rating/index";
import CertifiedComponent from "../CertifiedComponent/index";
import DoubleCol from "components/DoubleCol";
import ServiceStats from "components/ServiceStats";
import TranslationServiceGrid from "components/TranslationServiceGrid";
import FullWidthImage from "components/FullWidthImage";
import CaseStudyGrid from "components/CaseStudyGrid";
import SupportedLanguages from "components/SupportedLanguages";
import GlobalCta from "components/GlobalCta";
import SEO from "components/seo";
import FAQ from "components/FAQ";
import { FAQData } from "components/FAQ/config";

function ServicePages(props) {
  const pageData = props.pageContext.data;
  // console.log(pageData);

  return (
    <Layout>
      <SEO
        title={pageData.meta.meta_title}
        description={pageData.meta.meta_description}
        keywords={pageData.meta.meta_keywords}
        slug={pageData.slug}
      />
      {pageData.widgets &&
        pageData.widgets.map(({ widget, data }, i) => {
          if (widget === "block_1") {
            return (
              <div key={i}>
                <HeroBanner {...data} />
                {/* <UsersReviews
                  reviewsData={reviewsData}
                  containerStyling="bg-[#00173A] pb-16 pt-16"
                /> */}
              </div>
            );
          } else if (widget === "block_2") {
            return (
              <div key={i}>
                <ServiceClients data={data} />
              </div>
            );
          } else if (widget === "block_3") {
            return (
              <div key={i}>
                <CertificationSamples data={data} />
              </div>
            );
          } else if (widget === "block_4") {
            return (
              <div key={i}>
                <Rating {...data} />
              </div>
            );
          } else if (widget === "block_5") {
            return (
              <div key={i}>
                <CertifiedComponent data={data} />
              </div>
            );
          } else if (widget === "block_6") {
            return (
              <div key={i}>
                <DoubleCol data={data} />
              </div>
            );
          } else if (widget === "block_7") {
            return (
              <div key={i}>
                <ServiceStats data={data} />
              </div>
            );
          } else if (widget === "block_8") {
            return (
              <div key={i}>
                <TranslationServiceGrid data={data} />
              </div>
            );
          } else if (widget === "block_9") {
            return (
              <div key={i}>
                <FullWidthImage data={data} />
              </div>
            );
          } else if (widget === "block_10") {
            return (
              <div key={i}>
                <CaseStudyGrid data={data} />
              </div>
            );
          } else if (widget === "block_11") {
            return (
              <div key={i}>
                <SupportedLanguages data={data} />
              </div>
            );
          } else if (widget === "block_12") {
            return (
              <div key={i}>
                <GlobalCta data={data} />
              </div>
            );
          } else if (widget === "block_13") {
            return (
              <div key={i}>
                <FAQ data={data} />
              </div>
            );
          } else if (widget === "block_15") {
            return (
              <div key={i}>
                <CertifiedComponent data={data} />
              </div>
            );
          } else if (widget === "block_16") {
            return (
              <div key={i}>
                <DoubleCol data={data} />
              </div>
            );
          }
          return false;
        })}
      <GetInTouch />
    </Layout>
  );
}

export default ServicePages;
